import { useEffect, useRef } from "react";
import { trackViewContent } from "@/lib/tiktok-pixel";

const THRESHOLDS = [25, 50, 75, 100];

export const useScrollDepth = () => {
  const fired = useRef(new Set<number>());

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      const pct = Math.min((scrollTop / docHeight) * 100, 100);

      for (const t of THRESHOLDS) {
        if (pct >= t && !fired.current.has(t)) {
          fired.current.add(t);
          trackViewContent(`scroll_depth_${t}`, `Scroll ${t}%`, "engagement");
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
};
